import React from "react";
import { withRouter } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import HeaderContent from "../../components/layout/components/HeaderContent";
import CalculateCostFeaturesComponent from "./components/CalculateCostFeaturesComponent";

const CalculateCostFeatures = () => {
  const breadcrumb = [
    { link: "/calculateCostFeatures", title: "Calculate Cost Features" },
  ];

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle="Calculate Cost Features"
      />

      <Card>
        <CardContent>
          <CalculateCostFeaturesComponent />
        </CardContent>
      </Card>
    </>
  );
};

export default withRouter(CalculateCostFeatures);
